const getEnv = (key: string, defaultValue?: string) => {
  return process.env[key] || defaultValue
}

export const API_ADDRESS = getEnv('REACT_APP_API_ADDRESS', 'http://127.0.0.1:8002')
export const MAPBOX_TOKEN = 'pk.eyJ1IjoiYm5iZ3VhcmQ4ODgiLCJhIjoiY2p3Nzh5cXQ1MWkwbTQ1czBtNm84NDJlbSJ9.SPGwPhu1vILcPFOglKXvDw'
export const LOGINAPI_ADDRESS = 'https://login.bnbguard.com.au'
// export const LOGINAPI_ADDRESS = 'https://staging-users.bnbguard.com.au'
// export const LOGINAPI_ADDRESS = 'http://127.0.0.1:5010'
